import {FETCHED_PRICE} from '../actions/types';

let initialState = window.getStorage('bc-prices')

if(!initialState || (initialState && initialState.time + 1000 * 60 * 60 < Date.now())){
  initialState = {
    time: Date.now(),
    btc: 0,
    neo: 0,
    wav: 0,
    lsk: 0,
    eth: 0,
    emb: 0,
    'l-emb':0,
    usdt: 1,
    dai: 1,
    nrg: 0.1,
  };
}

export default function(state: Object = initialState, action) {
  switch (action.type) {
    case FETCHED_PRICE:
      state[action.payload.type] = action.payload.price;
      state.time = Date.now()
      window.setStorage('bc-prices',JSON.stringify(state))
      return {...state}
    default:
      return state;
  }
}
